export const WEIGHT_FIELD_DEFAULT_CLASSNAME =
  'w-max max-w-48 bg-transparent text-center font-montserrat text-9xl max-sm:text-3xl font-bold text-blue-8 outline-none placeholder:text-blue-13/80';

export const BUTTON_CLASSES =
  'rounded-2xl font-assistant text-lgm! font-bold disabled:bg-gray-2 disabled:group-hover:bg-gray-100 disabled:shadow-gray-100 flex h-16 w-full items-center justify-center bg-blue-1 px-3.5 text-white duration-200 hover:bg-blue-9 group-hover:bg-blue-9 focus-visible:outline-none';
export const OUTLINE_BUTTON_CLASSES =
  'font-assistant text-lgm! font-bold bg-transparent hover:bg-transparent group-hover:bg-none border border-gray-3 h-[4.13rem] rounded-2xl text-blue-1 disabled:bg-gray-1/40 disabled:opacity-70';

export const IMAGE_STACK_OPACITY_SCALE = {
  opacity: 1,
  scale: 1,
  x: 0,
  y: 0,
  rotate: 0,
};

export const COLORS: Record<string, string> = {
  transparent: 'transparent',
  black: '#000000',
  white: '#FFFFFF',
  'blue-1': '#357DED',
  'blue-2': '#ECF3FD',
  'blue-3': '#0050B4',
  'blue-4': '#454E57',
  'blue-5': '#001432',
  'blue-6': '#F6F9FE',
  'blue-7': '#BCD8FF',
  'blue-8': '#151D28',
  'blue-9': '#1462DC',
  'blue-12': '#d7e4f7',
  'blue-13': '#003485',
  'blue-14': '#F4F5FE',
  'blue-15': '#F4F8FF',
  'blue-16': '#D5E6FF',
  'blue-17': '#3D5AF1',
  'blue-18': '#D9DBE9',
  'blue-19': '#30415A',
  'blue-20': '#E6F1FF',
  'blue-21': '#0077FF',
  'blue-22': '#F6F6F7',
  'blue-23': '#E3E4E8',
  'blue-24': '#162941',
  'blue-25': '#001B44',
  'blue-26': '#A3C7FA',
  'blue-27': '#407BFF',
  'gray-1': '#CCCCCC',
  'gray-2': '#898989',
  'gray-3': '#B8C8E0',
  'gray-4': '#566781',
  'gray-5': '#787881',
  'gray-6': '#94A2B8',
  'gray-7': '#828282',
  'gray-8': '#EEF0FF',
  'gray-9': '#E6EAF0',
  'yellow-1': '#FEFBE7',
  'yellow-2': '#FBFCEC',
  'yellow-3': '#EDDC58',
  'yellow-4': '#E6E939',
  'yellow-5': '#FBFF3A',
  'yellow-6': '#F5F85C',
  'yellow-7': '#DBE939',
  'yellow-8': '#F7B44F',
  'yellow-9': '#FAD7A3',
  'yellow-10': '#FBB64E',
  'yellow-11': '#FFEED5',
  'yellow-12': '#FFCF23',
  'red-1': '#FCF3F3',
  'red-2': '#FF0000',
  'red-3': '#DC4440',
  'red-4': '#B9B6B6',
  'red-5': '#F5F5F5',
  'red-6': '#EFEFEF',
  'red-7': '#EDEDED',
  'red-8': '#FF1717',
  'red-9': '#ED0000',
  'brown-1': '#efebe9',
  'green-1': '#f3faf5',
  'green-2': '#00A35E',
  'green-3': '#23AE58',
  'green-4': '#04c473',
  'green-5': '#04C473',
  'green-6': '#11A85B',
  'green-12': '#00b77f',
  'green-13': '#34A853',
  'orange-1': '#F1EFEE',
  'orange-2': '#DFDEDD',
  'orange-3': '#E39C00',
  'orange-4': '#FFFCF5',
  'orange-5': '#FC5B2A',
  'orange-6': '#FFE6DF',
  'orange-7': '#f95b2b',
  'purple-1': '#4A3AFF',
  'purple-2': '#170F49',
  'purple-3': '#6F6C90',
  'cyan-1': '#B0EBDD',
} as const;
